export const helpers = {

	methods: {
		guid() {
			function s4() {
				return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
			}

			return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
		},

		confirm(message, callback) {
			this.$confirm({
				message: message,
				button: {
					no: 'No',
					yes: 'Yes'
				},
				callback: confirm => {
					if (confirm) {
						callback();
					}
				}
			});
		},

		successMessage(message) {
			Vue.$toast.open({
				message: message,
				type: 'success',
				position: 'top-right',
				duration: 3000,
				dismissible: true,
				pauseOnHover: true
			});
		},

		errorMessage(message) {
			Vue.$toast.open({
				message: message,
				type: 'error',
				position: 'top-right',
				duration: 3000,
				dismissible: true,
				pauseOnHover: true
			});
		},

		siteUrl() {
			return document.location.origin;
		},


	}
}